import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export var DrawerState;
(function (DrawerState) {
    DrawerState[DrawerState["closed"] = 1] = "closed";
    DrawerState[DrawerState["opened"] = 2] = "opened";
})(DrawerState || (DrawerState = {}));
var DrawerService = /** @class */ (function () {
    function DrawerService() {
        this.state$ = new BehaviorSubject(DrawerState.closed);
    }
    DrawerService.prototype.open = function () {
        this.state$.next(DrawerState.opened);
    };
    DrawerService.prototype.close = function () {
        this.state$.next(DrawerState.closed);
    };
    DrawerService.prototype.toggle = function () {
        this.state$.value === DrawerState.opened ? this.close() : this.open();
    };
    DrawerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DrawerService_Factory() { return new DrawerService(); }, token: DrawerService, providedIn: "root" });
    return DrawerService;
}());
export { DrawerService };
